module.exports = __webpack_public_path__ + "img/screen_mode_hover.39524b1b.png";